(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vq-subscribe-save"] && !Shopify.designMode) return;
  try {
    class VqSubscribeSave extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.#sync);
      // Capture on window so the plan is written before Horizon's document-level submit handler reads the form.
      window.addEventListener('submit', this.#onSubmit, true);
      this.#sync();
    }

    disconnectedCallback() {
      window.removeEventListener('submit', this.#onSubmit, true);
    }

    /** @param {Event} event */
    #onSubmit = (event) => {
      if (event.target instanceof HTMLFormElement && event.target.id === this.dataset.formId) this.#sync();
    };

    #sync = () => {
      const planInput = this.querySelector('input[name="selling_plan"]');
      const checked = this.querySelector('input[type="radio"]:checked');
      if (!(planInput instanceof HTMLInputElement)) return;

      const value = checked instanceof HTMLInputElement ? checked.value : '';
      planInput.value = value;
      planInput.disabled = value === '';

      for (const option of this.querySelectorAll('.vq-subscribe__option')) {
        option.classList.toggle('is-selected', option.contains(checked));
      }
    };
  }

  if (!customElements.get('vq-subscribe-save')) customElements.define('vq-subscribe-save', VqSubscribeSave);
  } catch(e) { console.error(e); }
})();

})();
